import React from 'react';
import Navbar from '../components/Navbar';
import ChatbotButton from '../components/ChatbotButton';
import '../styles/home.css';

const Home = () => {
  const cardData = [
    { image: "/images/invoice.png", content: "Pay Bills" },
    { image: "/images/car.png", content: "Traffic Fines" },
    { image: "/images/id-card.png", content: "ID Card" },
    { image: "/images/drivers-license.png", content: "Driving License" },
    { image: "/images/sedan.png", content: "Vehicle Registration" },
    { image: "/images/financial.png", content: "Residence Card" }
  ];

  return (
    <div className="home-container">
      <Navbar />
      <div className="quickAccess-container">Quick access</div>

      <div className="cards-container">
        {cardData.slice(0, 3).map((card, index) => (
          <div className="card" key={index}>
            <img src={card.image} alt={card.content} className="card-image" />
            <p>{card.content}</p>
          </div>
        ))}
      </div>

      <div className="cards-container">
        {cardData.slice(3, 6).map((card, index) => (
          <div className="card" key={index + 3}>
            <img src={card.image} alt={card.content} className="card-image" />
            <p>{card.content}</p>
          </div>
        ))}
      </div>

      <div className="featured-id">
        <h3>Featured</h3>
        <div className="b">
          <div className="c">
            your ID card here ..
          </div>
          <div className="id-card-info">
            <strong>My ID card</strong>
            <p>Ali Al-Lamki</p>
            <p>Valid until 2028</p>
          </div>
        </div>

      </div>

      <ChatbotButton />
    </div>
  );
};

export default Home;
